import { useNavigate, useParams } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import config from '../../config';
import { useEffect, useState } from 'react';
import { apiGifts } from '../../api/apiGifts.api';
import { toast } from 'react-toastify';
import chatService from '../../services/chat.service';
import SendGiftsModal from '../../components/gifts/SendGiftsModal';
import { ProfileExample } from '../../components/profile/ProfileExample';
import { apiMatch } from '../../api/apiMatch.api.js';
import { checkLimitError } from '../../components/limits/utils/checkLimitError.js';
import { LimitModal } from '../../components/limits/LimitModal.jsx';

function Streamer() {
  const params = useParams();

  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [isOpenPresentShop, setIsOpenPresentShop] = useState(false);
  const [limitsKey, setLimitsKey] = useState(null);

  const fetchUserProfile = async () => {
    try {
      const response = await axiosPrivate.get(`${config.API.USERS.BASE}/${params.id}`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  const onOpenChat = async () => {
    try {
      const res = await apiGifts.hasSentGift(axiosPrivate, params.id);
      if (res.data.data.hasSend) {
        await handleToFindOrCreateChat();
      } else {
        setIsOpenPresentShop(true);
      }
    } catch (error) {
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  const onSendGiftToStartChatting = async (giftId) => {
    try {
      const res = await apiGifts.sendGift(axiosPrivate, { recipientId: params.id, giftId: giftId });
      if (res.data.data.ok) {
        await handleToFindOrCreateChat();
      }
    } catch (error) {
      console.error('[Profile] Error sending gift:', error);
      toast.error(error.response.data.message || 'Ошибка отправки подарка');
    }
  };

  const handleToFindOrCreateChat = async () => {
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, userData._id);
      console.log('[Profile]', res);
      navigate(`/chats/${res.data._id}`);
    } catch (error) {
      console.error('[Profile] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  const handleLikeUser = async () => {
    try {
      await apiMatch.fetchLikeOrDisLike(axiosPrivate, { targetUserId: userData._id, like: true });
      toast.success('Лайк отправлен');
    } catch (error) {
      const message = error?.response?.data?.message;

      const limitKey = checkLimitError(message);

      if (limitKey) {
        setLimitsKey(limitKey);
      } else {
        toast.error(message);
      }
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <>
      {limitsKey && <LimitModal domain="swipe" limitsKey={limitsKey} setLimitsKey={setLimitsKey} />}
      <SendGiftsModal
        isOpen={isOpenPresentShop}
        onClose={() => setIsOpenPresentShop(false)}
        renderTitle={() => (
          <h2 className="text-[18px] font-semibold text-white text-center leading-[1.5] font-raleway">
            Обозначь себя, сделав человеку приятно. Это шаг к новым знакомствам!
          </h2>
        )}
        onSend={onSendGiftToStartChatting}
      />
      <ProfileExample
        userId={params.id}
        actionButtons={
          <>
            <button
              onClick={handleLikeUser}
              className="size-[58px] flex items-center justify-center rounded-full border-[2px] border-white bg-black/30"
            >
              <img src="/icons/heart.svg" alt="heart" />
            </button>
            <button
              onClick={onOpenChat}
              className="size-[58px] flex items-center justify-center rounded-full border-[2px] border-white bg-black/30"
            >
              <img src="/icons/chat.svg" alt="chat" />
            </button>
          </>
        }
      />
    </>
  );
}

export default Streamer;
